"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RightOfWayDetails$ = exports.RightOfWayDetails$outboundSchema = exports.RightOfWayDetails$inboundSchema = void 0;
exports.rightOfWayDetailsToJSON = rightOfWayDetailsToJSON;
exports.rightOfWayDetailsFromJSON = rightOfWayDetailsFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const rfcdate_js_1 = require("../../types/rfcdate.js");
const rightofwayrowtype_js_1 = require("./rightofwayrowtype.js");
/** @internal */
exports.RightOfWayDetails$inboundSchema = z.object({
    date_updated: z.nullable(z.string().transform(v => new rfcdate_js_1.RFCDate(v))),
    distance: z.nullable(z.number()),
    parish: z.nullable(z.string()),
    route_no: z.nullable(z.string()),
    row_type: z.nullable(rightofwayrowtype_js_1.RightOfWayRowType$inboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "date_updated": "dateUpdated",
        "route_no": "routeNo",
        "row_type": "rowType",
    });
});
/** @internal */
exports.RightOfWayDetails$outboundSchema = z.object({
    dateUpdated: z.nullable(z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString())),
    distance: z.nullable(z.number()),
    parish: z.nullable(z.string()),
    routeNo: z.nullable(z.string()),
    rowType: z.nullable(rightofwayrowtype_js_1.RightOfWayRowType$outboundSchema),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        dateUpdated: "date_updated",
        routeNo: "route_no",
        rowType: "row_type",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var RightOfWayDetails$;
(function (RightOfWayDetails$) {
    /** @deprecated use `RightOfWayDetails$inboundSchema` instead. */
    RightOfWayDetails$.inboundSchema = exports.RightOfWayDetails$inboundSchema;
    /** @deprecated use `RightOfWayDetails$outboundSchema` instead. */
    RightOfWayDetails$.outboundSchema = exports.RightOfWayDetails$outboundSchema;
})(RightOfWayDetails$ || (exports.RightOfWayDetails$ = RightOfWayDetails$ = {}));
function rightOfWayDetailsToJSON(rightOfWayDetails) {
    return JSON.stringify(exports.RightOfWayDetails$outboundSchema.parse(rightOfWayDetails));
}
function rightOfWayDetailsFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.RightOfWayDetails$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'RightOfWayDetails' from JSON`);
}
//# sourceMappingURL=rightofwaydetails.js.map